import { DirectivesModule } from './../directives/directives.module';
import { SharedModule } from './../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordResetConfirmationComponent } from './password-reset-confirmation/password-reset-confirmation.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordSetComponent } from './password-set/password-set.component';
import { PasswordSetConfirmationComponent } from './password-set-confirmation/password-set-confirmation.component';
import { AuthResetRoutingModule } from './auth-reset-routing.module';
import { AngularSvgIconModule } from 'angular-svg-icon';



@NgModule({
    declarations: [
        PasswordResetConfirmationComponent,
        PasswordResetComponent,
        PasswordSetComponent,
        PasswordSetConfirmationComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        DirectivesModule,
        AuthResetRoutingModule,
        AngularSvgIconModule,
    ]
})
export class AuthResetModule { }
